import script from "./English.vue?vue&type=script&setup=true&lang=js"
export * from "./English.vue?vue&type=script&setup=true&lang=js"

import "./English.vue?vue&type=style&index=0&id=0ab78672&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tests-frontend/tests-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ab78672"]])

export default __exports__